import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { SearchResultsSection } from '../SearchResultsSection/SearchResultsSection'

import { FundraiserCardSkeleton } from '@percent/workplace-giving/common/components/FundraiserCard/FundraiserCardSkeleton'
import { FundraiserCard } from '@percent/workplace-giving/common/components/FundraiserCard/FundraiserCard'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { formatNumberToLocale } from '@percent/workplace-giving/utils/formatNumberToLocale/formatNumberToLocale'
import { ListResponse } from '@percent/workplace-giving/api/goodstack'
import { SearchFundraiserResponse } from '@percent/workplace-giving/api/search/searchFundraisers/searchFundraisers.types'

type FundraisersResultsProps = Readonly<{
  data?: ListResponse<SearchFundraiserResponse>
  isFetching: boolean
  query?: string
  countryCode: string
}>

export function FundraisersResults({ data, isFetching, query, countryCode }: FundraisersResultsProps) {
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const items = useMemo(
    () =>
      data?.data?.map(f => ({
        id: f.fundraiser.id,
        content: (
          <FundraiserCard
            key={f.fundraiser.id}
            fundraiser={{
              id: f.fundraiser.id,
              imageUrl: f.fundraiser.page.imageUrl!,
              title: f.fundraiser.page.title,
              goal: f.fundraiser.campaign.goal,
              total: f.donationTotal,
              organisation: f.organisation
            }}
          />
        )
      })) ?? [],
    [data]
  )

  return (
    <SearchResultsSection
      title={t('workplace_giving.globalSearch.searchResults.fundraisers', {
        totalResults: formatNumberToLocale(language, data?.totalResults || 0)
      })}
      noResultsText={t('workplace_giving.globalSearch.searchResults.noFundraisers')}
      totalResults={data?.totalResults || 0}
      isFetching={isFetching}
      items={items}
      skeleton={<FundraiserCardSkeleton />}
      seeAllTo={`${AppRoute.FUNDRAISERS}?query=${query}&country=${countryCode}`}
    />
  )
}
